import { useState, useEffect } from "react";

// ─── NOTION PARAMS PAGE ─────────────────────────────────────────────────────
// ID de la page "🎛️ Paramètres Quiz" dans Notion
const PARAMS_PAGE_ID = "31c670ec-f7e1-81d8-929e-f93e20802aae";

// Lit la page Notion et parse les blocs de type "code" pour extraire KEY=VALUE
async function fetchNotionParams() {
  try {
    const res = await fetch("https://api.anthropic.com/v1/messages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        model: "claude-sonnet-4-20250514",
        max_tokens: 2000,
        mcp_servers: [{ type: "url", url: "https://mcp.notion.com/mcp", name: "notion" }],
        messages: [{
          role: "user",
          content: `Fetch the Notion page with ID "${PARAMS_PAGE_ID}" and return ONLY the raw text content of all code blocks, concatenated, nothing else. No explanation.`
        }]
      })
    });
    if (!res.ok) return {};
    const data = await res.json();
    const text = data.content?.filter(b => b.type === "text").map(b => b.text).join("\n") || "";
    // Parse KEY=VALUE
    const params = {};
    text.split("\n").forEach(line => {
      const m = line.match(/^([A-Z_]+)=(.*)$/);
      if (m) params[m[1]] = m[2].trim();
    });
    return params;
  } catch (e) {
    console.warn("Params Notion non chargés, valeurs par défaut utilisées.");
    return {};
  }
}

// ─── PALETTE — éditorial magazine power femme ──────────────────────────────
const C = {
  ink: "#0f0d0a",
  paper: "#f5f0e8",
  red: "#c8292a",
  redDark: "#9e1f20",
  redLight: "#f0d0d0",
  cream: "#faf6ee",
  charcoal: "#2a2520",
  warmGray: "#7a7060",
  border: "#d5cfc3",
  cardBg: "#faf8f4",
  white: "#ffffff",
  gold: "#b8873a",
  goldLight: "#e8d5a3",
};

const LOGO_B64 = "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";

const fonts = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;0,900;1,400;1,700&family=DM+Mono:wght@300;400;500&family=DM+Sans:wght@300;400;500&display=swap');
`;

// ─── DECISION ENGINE ────────────────────────────────────────────────────────
function compute(d, canaux) {
  const px = d.prix || 0;
  const format = d.format_offre || "recurrent";

  // Calcul CA actuel et capacité selon le format
  let ca_actuel, cap_max, ventes_mensuelles;

  if (format === "pack_1shot") {
    // Pack : ventes sur 3 mois / 4 = ventes mensuelles
    ventes_mensuelles = (d.ventes_3mois || 0) / 4;
    ca_actuel = px * ventes_mensuelles;
    // Capacité : combien de packs par mois (clients_max simultanés / durée en semaines * 4)
    const duree_mois = (d.duree_semaines || 4) / 5;
    cap_max = px * ((d.clients_max || 1) / duree_mois);
  } else if (format === "collectif") {
    // Club : revenus = membres × prix (annuel divisé par 12 si annuel, sinon tel quel)
    // On traite le prix comme une cotisation mensuelle équivalente
    const prix_mensuel_equiv = px / 22; // on suppose cotisation annuelle par défaut
    ca_actuel = prix_mensuel_equiv * (d.clients_actuels || 0);
    cap_max = prix_mensuel_equiv * (d.clients_max || 1);
    ventes_mensuelles = (d.ventes_3mois || 0) / 4;
  } else if (format === "digital") {
    ventes_mensuelles = d.ventes || 0;
    ca_actuel = px * ventes_mensuelles;
    cap_max = ca_actuel * 5; // pas de vraie limite, on met arbitrairement haut
  } else {
    // recurrent ou mixte
    ventes_mensuelles = d.ventes || 0;
    ca_actuel = px * ventes_mensuelles;
    cap_max = px * (d.clients_max || 1);
  }

  const util = cap_max > 0 ? ca_actuel / cap_max : 0;
  const ecart = Math.max(0, (d.objectif_ca || 0) - ca_actuel);
  const couverture = (d.objectif_ca || 0) > 0 ? cap_max / d.objectif_ca : 0;
  const clients_requis = d.objectif_ca > 0 && px > 0 ? Math.ceil(d.objectif_ca / px) : null;
  // Taux de conversion : priorité à l'échelle manuelle, sinon calcul prospects
  const taux_conv_obs = (d.prospects || 0) > 0 ? Math.min(ventes_mensuelles / d.prospects, 1) : null;
  const taux_conv_pct = d.conv_sur_10 ? (d.conv_sur_10 / 10) * 100 : (taux_conv_obs !== null ? taux_conv_obs * 100 : 0);
  const pression = (d.clients_max || 1) > 0 ? (d.clients_actuels || 0) / d.clients_max : 0;
  const ratio_temps = (d.heures_total || 1) > 0 ? (d.heures_clients || 0) / d.heures_total : 0;
  const nb_canaux = canaux.length;
  const util_pct = Math.min(Math.round(util * 100), 100);

  // Statut objectif
  let statut = couverture < 0.8 ? "non_atteignable" : couverture <= 1.1 ? "tendu" : "atteignable";

  // Pour le digital, pas de saturation possible
  const blocage_capacite_relevant = format !== "digital";

  // Blocages
  const acq_faible = (d.prospects || 0) < 5 && (d.demandes || 0) < 3;
  const sous_rempli = util < 0.6;
  const conv_faible = taux_conv_pct < 15 || d.offre_comprise === "non" || d.expliquer === "oui";
  const sature = blocage_capacite_relevant && (pression > 0.85 || d.saturation === "oui" || ratio_temps > 0.7);
  const dependance = d.sans_moi === "non" && d.process === "non" && d.saturation === "oui";
  const dispersion = nb_canaux >= 4 && d.canal_principal === "mal_defini";

  // Profil
  let profil = "business_invisible";
  let nuance = null;
  if (statut === "non_atteignable") {
    profil = "modele_plafonne";
    if (sature) nuance = "business_artisanal";
  } else if (sous_rempli && acq_faible) {
    profil = "business_invisible";
    if (dispersion) nuance = "croissance_dispersee";
  } else if (sous_rempli && !acq_faible && conv_faible) {
    profil = "offre_floue";
  } else if (dispersion) {
    profil = "croissance_dispersee";
  } else if (sature) {
    profil = "business_artisanal";
  }

  // Blocage principal
  let bp = "Pipeline commercial";
  if (statut === "non_atteignable") bp = "Modele economique";
  else if (sous_rempli && acq_faible) bp = "Acquisition";
  else if (conv_faible) bp = "Conversion offre";
  else if (sature) bp = "Saturation";
  else if (dispersion) bp = "Dispersion";

  return {
    ca_actuel, cap_max, util_pct, ecart, couverture, clients_requis,
    taux_conv_pct: Math.round(taux_conv_pct), pression, ratio_temps,
    nb_canaux, statut, profil, nuance, bp, dependance, dispersion, sature,
    sous_rempli, acq_faible,
  };
}

// ─── COPY ───────────────────────────────────────────────────────────────────
const PROFILS = {
  business_invisible: {
    label: "La Pépite cachée",
    color: C.sage,
    texte: "Votre modèle peut soutenir davantage de chiffre d'affaires, mais il n'est pas suffisamment alimenté en opportunités. Le levier, c'est la visibilité et l'acquisition — pas le produit.",
  },
  offre_floue: {
    label: "Le Potentiel dilué",
    color: C.gold,
    texte: "Le problème n'est pas tant la visibilité que la clarté commerciale de votre offre. Les prospects vous trouvent, mais ne comprennent pas assez vite pourquoi acheter chez vous — et maintenant.",
  },
  business_artisanal: {
    label: "L'Artisane talentueuse",
    color: "#d97316",
    texte: "Votre activité fonctionne, mais sa croissance repose encore trop directement sur votre temps. Chaque nouveau client ajoute de la pression, pas de la marge.",
  },
  croissance_dispersee: {
    label: "La Bâtisseuse dispersée",
    color: "#7c5cbb",
    texte: "Votre business ne manque pas de potentiel — il manque de concentration stratégique. Trop de canaux, trop de directions simultanées.",
  },
  modele_plafonne: {
    label: "La Visionnaire bridée",
    color: C.rust,
    texte: "Même en remplissant votre capacité à 100%, votre modèle actuel crée un plafond économique en dessous de votre objectif.",
  },
};

const PRIORITES = {
  business_invisible: {
    augmenter_ca: [
      { t: "Créer un canal d'acquisition principal", d: "Choisir un seul canal et y être systématique pendant 90 jours." },
      { t: "Développer un pipeline de prospects qualifiés", d: "Objectif : doubler le volume de prospects mensuels d'ici 6 semaines." },
      { t: "Automatiser la prise de contact initiale", d: "Séquence email ou point d'entrée clair pour capter et nourrir les leads." },
    ],
    attirer_clients: [
      { t: "Stratégie de contenu ciblée", d: "3 à 5 contenus par semaine qui parlent directement aux douleurs de ta cible." },
      { t: "Activer le réseau existant", d: "Reprendre contact avec d'anciens clients pour générer des recommandations." },
      { t: "Créer un lead magnet à forte valeur", d: "Quiz, audit ou template qui génère des contacts qualifiés chaque semaine." },
    ],
    default: [
      { t: "Choisir un canal d'acquisition principal", d: "Focus sur un seul canal pendant 90 jours pour construire une vraie dynamique." },
      { t: "Augmenter la visibilité de l'offre", d: "Parler de ton offre plus souvent, plus clairement, sous différents angles." },
      { t: "Activer les recommandations", d: "Demander systématiquement des recommandations à chaque cliente satisfaite." },
    ],
  },
  offre_floue: {
    default: [
      { t: "Retravailler la promesse de l'offre", d: "Une phrase. Un résultat. Zéro jargon. Compris en 10 secondes." },
      { t: "Créer une page de vente claire et directe", d: "Pour qui, pour quoi, pourquoi toi, et quel résultat concret." },
      { t: "Tester le discours commercial", d: "3 conversations de vente cette semaine avec des prospects froids." },
    ],
  },
  business_artisanal: {
    ameliorer_rentabilite: [
      { t: "Documenter tes process clés", d: "Cartographier ce que tu fais pour chaque client, identifier ce qui peut être délégué." },
      { t: "Revoir le pricing ou la structure d'offre", d: "Augmenter le prix ou passer sur un format groupe pour décorréler temps et revenu." },
      { t: "Définir ta capacité soutenable réelle", d: "Le nombre de clients qui te permettent de travailler bien — sans saturation." },
    ],
    reduire_charge: [
      { t: "Documenter et déléguer une tâche par semaine", d: "Commencer par ce qui prend du temps sans créer de valeur directe pour le client." },
      { t: "Créer un produit qui complète l'offre service", d: "Groupe, programme ou ressource pour ne pas tout livrer en 1:1." },
      { t: "Définir tes règles de capacité non négociables", d: "Max clients, heures delivery max, temps libre garanti — noir sur blanc." },
    ],
    default: [
      { t: "Documenter les process clients", d: "Standardiser l'onboarding, le suivi et l'offboarding pour gagner du temps." },
      { t: "Créer un format scalable", d: "Groupe, programme en ligne, atelier — toucher plus de monde avec le même temps." },
      { t: "Augmenter le prix de l'offre principale", d: "Travailler moins, facturer plus. Souvent la voie la plus directe." },
    ],
  },
  croissance_dispersee: {
    default: [
      { t: "Choisir UN canal principal et l'habiter vraiment", d: "Arrêter d'être partout. En profondeur sur un seul canal pendant 90 jours." },
      { t: "Clarifier la priorité des 90 prochains jours", d: "Un seul objectif business mesurable, toutes les actions alignées dessus." },
      { t: "Supprimer 2 actions récurrentes qui ne convertissent pas", d: "Désencombrer le plan d'action pour créer de l'espace pour ce qui fonctionne." },
    ],
  },
  modele_plafonne: {
    changer_echelle: [
      { t: "Revoir le modèle économique de fond en comble", d: "Explorer : groupe, produit digital, licence, formation, montée en gamme du prix." },
      { t: "Documenter le système complet", d: "Rendre le business moins dépendant de ta présence avant d'accélérer." },
      { t: "Définir le prochain modèle cible", d: "Où est le plafond de CA dans le nouveau modèle ? Peut-il soutenir l'objectif sur 2 ans ?" },
    ],
    default: [
      { t: "Retravailler le modèle économique", d: "Augmenter significativement le prix ou changer la structure." },
      { t: "Augmenter la capacité maximale", d: "Explorer délégation, process, outils pour accepter plus de clients sans saturer." },
      { t: "Définir le plafond du modèle cible", d: "Construire le nouveau modèle dès maintenant, en parallèle." },
    ],
  },
};

function getPrios(profil, objectif) {
  const p = PRIORITES[profil];
  if (!p) return PRIORITES.business_invisible.default;
  return p[objectif] || p.default || PRIORITES.business_invisible.default;
}

function fmt(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}

// ─── WEBHOOK CONFIG ───────────────────────────────────────────────────────────
// 👇 Remplace cette URL par ton webhook Make une fois créé

// ─── SEND TO MAKE WEBHOOK ────────────────────────────────────────────────────
async function sendToWebhook(payload, url) {
  const webhookUrl = url || "https://hook.eu1.make.com/4uorkiofpmgt4r13drgeewwndadfy2pa";
  if (!webhookUrl) {
    console.warn("Webhook Make non configuré.");
    return false;
  }
  try {
    const res = await fetch(webhookUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    return res.ok;
  } catch (e) {
    console.error("Erreur webhook:", e);
    return false;
  }
}

// ─── STYLES ──────────────────────────────────────────────────────────────────
const S = {
  root: {
    fontFamily: "'DM Sans', sans-serif",
    background: C.paper,
    minHeight: "100vh",
    color: C.ink,
  },
  header: {
    background: C.ink,
    color: C.cream,
    padding: "32px 48px 28px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 12,
    position: "relative",
    borderBottom: `3px solid ${C.red}`,
  },
  logoText: {
    fontFamily: "'DM Mono', monospace",
    fontSize: 10,
    letterSpacing: "0.22em",
    textTransform: "uppercase",
    opacity: 0.5,
  },
  headerTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 20,
    fontWeight: 400,
    letterSpacing: "0.04em",
  },
  progressTrack: { height: 3, background: C.border },
  main: { maxWidth: 680, margin: "0 auto", padding: "56px 24px 80px" },
  tag: {
    fontFamily: "'DM Mono', monospace",
    fontSize: 10,
    letterSpacing: "0.25em",
    textTransform: "uppercase",
    color: C.red,
    marginBottom: 12,
  },
  h1: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 36,
    fontWeight: 700,
    lineHeight: 1.2,
    marginBottom: 8,
  },
  desc: { color: C.warmGray, fontSize: 14, marginBottom: 36, fontWeight: 300 },
  card: {
    background: C.white,
    border: `1px solid ${C.border}`,
    borderRadius: 0,
    padding: "20px 24px",
    marginBottom: 24,
  },
  label: { fontSize: 14, fontWeight: 500, marginBottom: 10 },
  input: {
    width: "100%",
    background: C.white,
    border: `1.5px solid ${C.border}`,
    borderRadius: 0,
    padding: "12px 14px",
    fontFamily: "'DM Mono', monospace",
    fontSize: 15,
    color: C.ink,
    outline: "none",
    boxSizing: "border-box",
    borderBottom: `2px solid ${C.ink}`,
  },
  hint: { fontSize: 11, color: C.warmGray, marginTop: 5, fontStyle: "italic" },
  choiceGrid: (cols) => ({
    display: "grid",
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gap: 8,
  }),
  choiceBtn: (sel) => ({
    background: sel ? C.redLight : C.white,
    border: `1.5px solid ${sel ? C.red : C.border}`,
    borderRadius: 0,
    padding: "11px 14px",
    textAlign: "left",
    cursor: "pointer",
    fontSize: 13,
    color: C.ink,
    fontWeight: sel ? 500 : 400,
    lineHeight: 1.45,
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    fontFamily: "'DM Sans', sans-serif",
    transition: "all 0.15s",
  }),
  check: (sel) => ({
    width: 14,
    height: 14,
    minWidth: 14,
    border: `1.5px solid ${sel ? C.red : C.border}`,
    borderRadius: 0,
    background: sel ? C.red : "transparent",
    marginTop: 1,
    transition: "all 0.15s",
  }),
  scaleRow: { display: "flex", gap: 6 },
  scaleBtn: (sel) => ({
    flex: 1,
    height: 44,
    background: sel ? C.red : C.white,
    border: `1.5px solid ${sel ? C.red : C.border}`,
    borderRadius: 0,
    cursor: "pointer",
    fontFamily: "'DM Mono', monospace",
    fontSize: 13,
    color: sel ? C.white : C.warmGray,
    fontWeight: sel ? 600 : 400,
    transition: "all 0.15s",
  }),
  nav: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 36,
    paddingTop: 20,
    borderTop: `1px solid ${C.border}`,
  },
  btnBack: {
    background: "none",
    border: "none",
    fontFamily: "'DM Mono', monospace",
    fontSize: 11,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: C.warmGray,
    cursor: "pointer",
  },
  btnNext: (red) => ({
    background: red ? C.red : C.ink,
    color: C.white,
    border: "none",
    borderRadius: 0,
    padding: "14px 32px",
    fontFamily: "'DM Mono', monospace",
    fontSize: 11,
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    cursor: "pointer",
    transition: "opacity 0.15s",
    borderBottom: `3px solid ${red ? C.redDark : "#000"}`,
  }),
  counter: {
    fontFamily: "'DM Mono', monospace",
    fontSize: 11,
    color: C.warmGray,
    letterSpacing: "0.1em",
  },
  // Results
  rHeader: { textAlign: "center", padding: "48px 0 36px", borderBottom: `1px solid ${C.border}`, marginBottom: 40 },
  rEyebrow: { fontFamily: "'DM Mono', monospace", fontSize: 10, letterSpacing: "0.25em", textTransform: "uppercase", color: C.red, marginBottom: 14 },
  rTitle: { fontFamily: "'Playfair Display', serif", fontSize: 38, fontWeight: 700, lineHeight: 1.2, marginBottom: 10 },
  rSub: { color: C.warmGray, fontSize: 14, maxWidth: 480, margin: "0 auto" },
  verdict: (type) => ({
    borderRadius: 0,
    padding: "24px 28px",
    marginBottom: 24,
    borderLeft: `4px solid ${type === "atteignable" ? "#2d6a4f" : type === "tendu" ? C.gold : C.red}`,
    background: type === "atteignable" ? "#f0f4f1" : type === "tendu" ? "#fdf8ee" : "#fdf0f0",
  }),
  bloc: {
    background: C.cardBg,
    border: `1px solid ${C.border}`,
    borderRadius: 0,
    borderTop: `3px solid ${C.ink}`,
    padding: "24px 28px",
    marginBottom: 20,
  },
  blocTag: { fontFamily: "'DM Mono', monospace", fontSize: 10, letterSpacing: "0.25em", textTransform: "uppercase", color: C.red, marginBottom: 10 },
  blocTitle: { fontFamily: "'Playfair Display', serif", fontSize: 22, fontWeight: 700, marginBottom: 16 },
  metricsGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 },
  metricCard: { background: C.white, border: `1px solid ${C.border}`, borderRadius: 0, padding: "16px 18px", borderTop: `2px solid ${C.red}` },
  metricLabel: { fontFamily: "'DM Mono', monospace", fontSize: 9, letterSpacing: "0.2em", textTransform: "uppercase", color: C.warmGray, marginBottom: 6 },
  metricVal: { fontFamily: "'Playfair Display', serif", fontSize: 30, lineHeight: 1, color: C.ink, marginBottom: 3 },
  metricSub: { fontSize: 11, color: C.warmGray },
  profilBadge: (color) => ({
    display: "inline-block",
    background: C.ink,
    color: C.white,
    padding: "6px 16px",
    borderRadius: 0,
    fontFamily: "'DM Mono', monospace",
    fontSize: 11,
    fontWeight: 500,
    letterSpacing: "0.15em",
    textTransform: "uppercase",
    marginBottom: 14,
    borderLeft: `4px solid ${color}`,
  }),
  profilText: {
    fontSize: 14,
    lineHeight: 1.75,
    fontStyle: "italic",
    borderLeft: `3px solid ${C.red}`,
    paddingLeft: 16,
    color: C.ink,
  },
  prioItem: {
    display: "flex",
    gap: 16,
    padding: "16px 0",
    borderBottom: `1px solid ${C.border}`,
    alignItems: "flex-start",
  },
  prioNum: { fontFamily: "'Playfair Display', serif", fontSize: 28, color: C.red, lineHeight: 1, minWidth: 28 },
  notionBadge: (ok) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    marginTop: 20,
    padding: "10px 20px",
    background: ok === true ? "#f0f4f1" : ok === false ? "#fdf0f0" : C.paper,
    borderLeft: `3px solid ${ok === true ? "#2d6a4f" : ok === false ? C.red : C.border}`,
    fontFamily: "'DM Mono', monospace",
    fontSize: 11,
    letterSpacing: "0.1em",
    color: ok === true ? "#2d6a4f" : ok === false ? C.red : C.warmGray,
  }),
};

// ─── COMPONENTS ─────────────────────────────────────────────────────────────
function ChoiceBtn({ label, selected, onClick, multi }) {
  return (
    <button style={S.choiceBtn(selected)} onClick={onClick}>
      <span style={S.check(selected)} />
      <span>{label}</span>
    </button>
  );
}

function ScaleInput({ value, onChange, min = 1, max = 10 }) {
  return (
    <div>
      <div style={S.scaleRow}>
        {Array.from({ length: max - min + 1 }, (_, i) => i + min).map((n) => (
          <button key={n} style={S.scaleBtn(value === n)} onClick={() => onChange(n)}>{n}</button>
        ))}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 5, fontSize: 11, color: C.warmGray, fontStyle: "italic" }}>
        <span>Très peu</span><span>La plupart</span>
      </div>
    </div>
  );
}

function NumberInput({ id, placeholder, value, onChange, hint }) {
  return (
    <div>
      <input
        type="number"
        style={S.input}
        placeholder={placeholder}
        value={value ?? ""}
        min={0}
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === "" ? "" : parseFloat(v));
        }}
      />
      {hint && <div style={S.hint}>{hint}</div>}
    </div>
  );
}

function TextInput({ placeholder, value, onChange, hint, autoComplete }) {
  return (
    <div>
      <input
        type="text"
        style={S.input}
        placeholder={placeholder}
        value={value || ""}
        autoComplete={autoComplete || "off"}
        onChange={(e) => onChange(e.target.value)}
      />
      {hint && <div style={S.hint}>{hint}</div>}
    </div>
  );
}

function Question({ label, required, children }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={S.label}>
        {label}
        {required && <span style={{ color: C.red, marginLeft: 4 }}>*</span>}
      </div>
      {children}
    </div>
  );
}

function UtilBar({ pct }) {
  const color = pct < 60 ? "#2d6a4f" : pct < 85 ? C.gold : C.red;
  const interp = pct < 60 ? "Business sous-rempli — capacité non exploitée." : pct < 85 ? "Capacité confortable — bon équilibre." : "Business proche du plafond — tension sur la delivery.";
  return (
    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `2px solid ${C.ink}`, padding: "16px 18px", marginBottom: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
        <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, letterSpacing: "0.2em", textTransform: "uppercase", color: C.warmGray }}>Taux d'utilisation</span>
        <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 14, fontWeight: 500 }}>{pct}%</span>
      </div>
      <div style={{ height: 4, background: C.border, overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${pct}%`, background: color, transition: "width 1s ease" }} />
      </div>
      <div style={{ marginTop: 8, fontSize: 12, color: C.warmGray, fontStyle: "italic" }}>{interp}</div>
    </div>
  );
}

// ─── MAIN APP ────────────────────────────────────────────────────────────────
export default function DiagnosticApp() {
  const [step, setStep] = useState(0);
  const [d, setD] = useState({});
  const [canaux, setCanaux] = useState([]);
  const [results, setResults] = useState(null);
  const [, setNotionStatus] = useState(null);
  const [params, setParams] = useState({});
  const [, setParamsLoaded] = useState(false);
  const [errors, setErrors] = useState({});

  // Charge les paramètres depuis Notion au démarrage
  useEffect(() => {
    fetchNotionParams().then(p => {
      setParams(p);
      setParamsLoaded(true);
    });
  }, []);

  const set = (k, v) => setD((prev) => ({ ...prev, [k]: v }));
  const toggleCanal = (v) => setCanaux((prev) => prev.includes(v) ? prev.filter((x) => x !== v) : [...prev, v]);

  const progress = step === 0 ? 0 : (step / 5) * 100;

  const go = (s) => {
    if (s > step) {
      let err = null;
      if (step === 0) {
        if (!d.prenom?.trim()) err = "Ton prénom est requis.";
        else if (!d.email?.trim()) err = "Ton email est requis.";
        else if (!d.rgpd) err = "Merci d'accepter les conditions pour continuer.";
        if (err) { setErrors({ intro: err }); return; }
      }
      if (step === 1) {
        if (!d.secteur) { setErrors({ s1: "Sélectionne ton secteur d'activité." }); return; }
        if (!d.format_offre) { setErrors({ s1: "Sélectionne le format de ton offre principale." }); return; }
      }
      if (step === 2) {
        if (!d.objectif_principal) { setErrors({ s2: "Sélectionne ton objectif principal." }); return; }
        if (!d.objectif_ca) { setErrors({ s2: "L'objectif de CA est requis." }); return; }
      }
      if (step === 3) {
        if (!d.prix) { setErrors({ s3: "Le prix de ton offre est requis." }); return; }
        if (d.format_offre === "pack_1shot" || d.format_offre === "collectif") {
          if (!d.clients_max) { setErrors({ s3: "La capacité est requise." }); return; }
          if (!d.clients_actuels && d.clients_actuels !== 0) { setErrors({ s3: "Le nombre actuel est requis." }); return; }
          if (!d.ventes_3mois && d.ventes_3mois !== 0) { setErrors({ s3: "Le nombre de ventes est requis." }); return; }
        } else {
          if (!d.ventes && d.ventes !== 0) { setErrors({ s3: "Le nombre de ventes est requis." }); return; }
          if (d.format_offre !== "digital" && !d.clients_actuels && d.clients_actuels !== 0) { setErrors({ s3: "Le nombre de clients est requis." }); return; }
          if (d.format_offre !== "digital" && !d.clients_max) { setErrors({ s3: "La capacité max est requise." }); return; }
        }
      }
      if (step === 4) {
        if (!d.prospects && d.prospects !== 0) { setErrors({ s4: "Le nombre de prospects est requis." }); return; }
      }
      if (step === 5) {
        if (!d.conv_sur_10 && d.conv_sur_10 !== 0) { setErrors({ s5: "La conversion est requise." }); return; }
      }
    }
    setErrors({});
    setStep(s);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const choicesObj = (field, opts, cols = 1) => (
    <div style={S.choiceGrid(cols)}>
      {opts.map(([val, label]) => (
        <ChoiceBtn key={val} label={label} selected={d[field] === val} onClick={() => set(field, val)} />
      ))}
    </div>
  );

  const multiCheck = (val, label) => (
    <ChoiceBtn key={val} label={label} selected={canaux.includes(val)} onClick={() => toggleCanal(val)} multi />
  );

  function handleSubmit() {
    // Validation finale avant de soumettre
    if (!d.conv_sur_10 && d.conv_sur_10 !== 0) { setErrors({ s5: "La conversion est requise." }); return; }
    const r = compute(d, canaux);
    const prios = getPrios(r.profil, d.objectif_principal);
    r.prios = prios;
    setResults(r);
    setErrors({});
    setStep(6);
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Webhook URL depuis Notion params ou fallback
    const webhookUrl = params["MAKE_WEBHOOK_URL"] || "https://hook.eu1.make.com/4uorkiofpmgt4r13drgeewwndadfy2pa";
    const objectifLabels = {
      augmenter_ca: "Augmenter CA", ameliorer_rentabilite: "Ameliorer rentabilite",
      attirer_clients: "Attirer clients", structurer: "Structurer",
      reduire_charge: "Reduire charge", changer_echelle: "Changer echelle",
    };
    const profilLabels = {
      business_invisible: "La Pepite cachee", offre_floue: "Le Potentiel dilue",
      business_artisanal: "LArticsane talentueuse", croissance_dispersee: "La Batisseuse dispersee",
      modele_plafonne: "La Visionnaire bridee",
    };
    const statutLabels = { atteignable: "Atteignable", tendu: "Tendu", non_atteignable: "Non atteignable" };

    const secteurLabels = {
      service_expertise: "Service & expertise", creatif_artisan: "Créatif & artisanat",
      formation_contenu: "Formation & contenu", communaute_evenement: "Communauté & événementiel",
      produit_ecommerce: "Produit physique / e-commerce", autre: "Autre",
    };
    const formatLabels = {
      recurrent: "Récurrent mensuel", pack_1shot: "Pack / 1 shot",
      collectif: "Collectif / Club", digital: "Produit digital", mixte: "Mixte",
    };

    const payload = {
      Prenom: (d.prenom || "Anonyme").trim(),
      Email: d.email || null,
      Telephone: d.telephone || null,
      "Nom business": d.nom_business || "",
      Secteur: secteurLabels[d.secteur] || d.secteur || "",
      "Format offre": formatLabels[d.format_offre] || d.format_offre || "",
      "date:Date:start": new Date().toISOString().split("T")[0],
      "date:Date:is_datetime": 0,
      Profil: profilLabels[r.profil] || r.profil,
      "Statut objectif": statutLabels[r.statut] || r.statut,
      "Objectif principal": objectifLabels[d.objectif_principal] || "",
      "CA actuel": r.ca_actuel,
      "CA max potentiel": r.cap_max,
      "Taux conversion (%)": r.taux_conv_pct,
      "Objectif CA": d.objectif_ca || 0,
      "Ecart objectif": r.ecart,
      "Prix offre principale": d.prix || 0,
      "Canaux utilises": canaux.map(c => ({
        "reseaux_sociaux": "Reseaux sociaux",
        "bouche_oreille": "Bouche a oreille",
        "contenu": "Contenu",
        "publicite": "Publicite payante",
        "evenements": "Evenements",
        "mixte": "Mixte"
      }[c] || c)).join(";"),
      "Blocage principal": r.bp,
      "Blocage secondaire": r.nuance ? profilLabels[r.nuance] : "",
      "Priorite 1": prios[0]?.t || "",
      "Priorite 2": prios[1]?.t || "",
      "Priorite 3": prios[2]?.t || "",
      Suivi: "Nouveau",
    };

    setNotionStatus("sending");
    sendToWebhook(payload, webhookUrl).then((ok) => setNotionStatus(ok)).catch(() => setNotionStatus(false));
  }

  function restart() {
    setD({}); setCanaux([]); setResults(null); setNotionStatus(null); go(0);
  }

  // ── RENDER ──
  return (
    <div style={S.root}>
      <style>{fonts}</style>

      {/* HEADER */}
      <div style={S.header}>
        {/* Compteur étape en absolu */}
        <span style={{ position: "absolute", right: 24, top: "50%", transform: "translateY(-50%)", fontFamily: "'DM Mono', monospace", fontSize: 11, color: "rgba(255,255,255,0.25)", letterSpacing: "0.1em" }}>
          {step > 0 && step < 6 ? `${step} / 5` : ""}
        </span>

        {/* Logo direct sur fond encre */}
        <img
          src={`data:image/png;base64,${LOGO_B64}`}
          alt="Women With A Plan"
          style={{ width: 64, height: 64, objectFit: "contain", display: "block" }}
        />

        {/* Nom du questionnaire */}
        <div style={{ textAlign: "center" }}>
          <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, fontWeight: 700, color: C.paper, letterSpacing: "0.04em", marginBottom: 3 }}>
            Strategic Clarity Score
          </div>
          <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, color: "rgba(245,240,232,0.55)", letterSpacing: "0.22em", textTransform: "uppercase" }}>
            par Women With A Plan
          </div>
        </div>
      </div>

      {/* PROGRESS */}
      <div style={S.progressTrack}>
        <div style={{ height: 3, background: C.red, width: `${progress}%`, transition: "width 0.4s ease" }} />
      </div>

      <div style={S.main}>

        {/* ── STEP 0 : CONTACT ── */}
        {step === 0 && (
          <div>
            <div style={S.tag}>Strategic Clarity Score</div>
            <h1 style={S.h1}>Où en est ton business,<br /><em>vraiment ?</em></h1>
            <p style={S.desc}>5 minutes pour obtenir un diagnostic stratégique clair sur ce qui freine ta croissance.</p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 28 }}>
              {[
                ["01", "Ton profil stratégique"],
                ["02", "Ce qui freine ta croissance"],
                ["03", "Tes 3 priorités pour les 90 prochains jours"],
              ].map(([num, label]) => (
                <div key={num} style={{ display: "flex", alignItems: "center", gap: 14, padding: "12px 16px", borderLeft: `3px solid ${C.red}`, background: "rgba(200,41,42,0.04)" }}>
                  <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, color: C.red, letterSpacing: "0.1em", minWidth: 20 }}>{num}</span>
                  <span style={{ fontSize: 13, color: C.ink, fontWeight: 500 }}>{label}</span>
                </div>
              ))}
            </div>
            <Question label="Ton prénom" required>
              <TextInput placeholder="ex. Sophie" value={d.prenom} onChange={(v) => set("prenom", v)} autoComplete="given-name" />
            </Question>
            <Question label="Ton email" required>
              <TextInput placeholder="ex. sophie@monbusiness.com" value={d.email} onChange={(v) => set("email", v)} autoComplete="email" />
            </Question>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 12, marginBottom: 8, marginTop: 4 }}>
              <div
                onClick={() => set("rgpd", !d.rgpd)}
                style={{ width: 18, height: 18, minWidth: 18, border: `2px solid ${d.rgpd ? C.red : C.border}`, background: d.rgpd ? C.red : "transparent", cursor: "pointer", marginTop: 2, display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.15s" }}
              >
                {d.rgpd && <span style={{ color: C.white, fontSize: 11, lineHeight: 1 }}>✓</span>}
              </div>
              <span style={{ fontSize: 12, color: C.warmGray, lineHeight: 1.6, cursor: "pointer" }} onClick={() => set("rgpd", !d.rgpd)}>
                J'accepte que Women With A Plan m'envoie des emails.
              </span>
            </div>
            {errors.intro && <div style={{ color: C.red, fontSize: 12, fontFamily: "'DM Mono', monospace", marginBottom: 12 }}>{errors.intro}</div>}
            <div style={{ ...S.nav, border: "none", padding: 0, marginTop: 24 }}>
              <span />
              <button style={S.btnNext(false)} onClick={() => go(1)}>Commencer →</button>
            </div>
          </div>
        )}

        {/* ── STEP 1 : ACTIVITÉ ── */}
        {step === 1 && (
          <div>
            <div style={S.tag}>Étape 1 / 5 — Ton activité</div>
            <h2 style={S.h1}>Parle-moi de<br /><em>ton business.</em></h2>
            <Question label="Nom de ton business">
              <TextInput placeholder="ex. Studio Lumière" value={d.nom_business} onChange={(v) => set("nom_business", v)} />
            </Question>
            <Question label="Comment se structure ton offre principale ?" required>
              {choicesObj("format_offre", [
                ["recurrent", "Accompagnement récurrent (mensuel / trimestriel)"],
                ["pack_1shot", "Pack ou offre 1 shot (durée définie, prix fixe)"],
                ["collectif", "Offre collective (groupe, club, mastermind)"],
                ["digital", "Produit digital (formation enregistrée, template…)"],
                ["mixte", "Mixte"],
              ])}
            </Question>
            <Question label="Ton domaine d'activité" required>
              {choicesObj("secteur", [
                ["service_expertise", "Service & expertise"],
                ["creatif_artisan", "Créatif & artisanat"],
                ["formation_contenu", "Formation & contenu"],
                ["communaute_evenement", "Communauté & événementiel"],
                ["produit_ecommerce", "Produit physique / e-commerce"],
                ["autre", "Autre"],
              ], 2)}
            </Question>
            {errors.s1 && <div style={{ color: C.red, fontSize: 12, fontFamily: "'DM Mono', monospace", marginTop: 8 }}>{errors.s1}</div>}
            <div style={S.nav}>
              <button style={S.btnBack} onClick={() => go(0)}>← Retour</button>
              <span style={S.counter}>1 / 5</span>
              <button style={S.btnNext(false)} onClick={() => go(2)}>Suivant →</button>
            </div>
          </div>
        )}

        {/* ── STEP 2 : OBJECTIF ── */}
        {step === 2 && (
          <div>
            <div style={S.tag}>Étape 2 / 5 — Objectif</div>
            <h2 style={S.h1}>Où veux-tu aller ?</h2>
            <p style={S.desc}>Ces réponses orientent l'ensemble du diagnostic.</p>
            <Question label="Ton objectif principal en ce moment" required>
              {choicesObj("objectif_principal", [
                ["augmenter_ca", "Augmenter mon chiffre d'affaires"],
                ["ameliorer_rentabilite", "Améliorer ma rentabilité"],
                ["attirer_clients", "Attirer plus de clients"],
                ["structurer", "Structurer mon business"],
                ["reduire_charge", "Réduire ma charge de travail"],
                ["changer_echelle", "Préparer un changement d'échelle"],
              ])}
            </Question>
            <Question label="Objectif de CA mensuel (€)" required>
              <NumberInput placeholder="ex. 8000" value={d.objectif_ca} onChange={(v) => set("objectif_ca", v)} hint="En euros, hors taxes." />
            </Question>
            <Question label="Dans quel horizon ?">
              {choicesObj("horizon", [["3mois", "3 mois"], ["6mois", "6 mois"], ["12mois", "12 mois"]], 3)}
            </Question>
            {errors.s2 && <div style={{ color: C.red, fontSize: 12, fontFamily: "'DM Mono', monospace", marginTop: 8 }}>{errors.s2}</div>}
            <div style={S.nav}>
              <button style={S.btnBack} onClick={() => go(1)}>← Retour</button>
              <span style={S.counter}>2 / 5</span>
              <button style={S.btnNext(false)} onClick={() => go(3)}>Suivant →</button>
            </div>
          </div>
        )}

        {/* ── STEP 3 : MODÈLE ÉCONOMIQUE ── */}
        {step === 3 && (
          <div>
            <div style={S.tag}>Étape 3 / 5 — Modèle économique</div>
            <h2 style={S.h1}>Les chiffres de<br /><em>ton activité.</em></h2>
            <p style={S.desc}>Au plus proche de la réalité actuelle. Il n'y a pas de bonnes réponses.</p>

            {(d.format_offre === "recurrent" || d.format_offre === "mixte" || !d.format_offre) && (
              <>
                <Question label="Prix de ton offre principale (€ / client / mois)" required>
                  <NumberInput placeholder="ex. 1500" value={d.prix} onChange={(v) => set("prix", v)} hint="Si tu as plusieurs offres, prends celle qui génère le plus de CA." />
                </Question>
                <Question label="Ventes par mois en moyenne" required>
                  <NumberInput placeholder="ex. 2" value={d.ventes} onChange={(v) => set("ventes", v)} />
                </Question>
                <Question label="Clients actifs en ce moment" required>
                  <NumberInput placeholder="ex. 3" value={d.clients_actuels} onChange={(v) => set("clients_actuels", v)} />
                </Question>
                <Question label="Combien de clients peux-tu gérer simultanément au maximum ?" required>
                  <NumberInput placeholder="ex. 6" value={d.clients_max} onChange={(v) => set("clients_max", v)} hint="En termes de temps et d'énergie." />
                </Question>
              </>
            )}

            {d.format_offre === "pack_1shot" && (
              <>
                <Question label="Prix de ton offre (€ par pack / client)" required>
                  <NumberInput placeholder="ex. 3000" value={d.prix} onChange={(v) => set("prix", v)} hint="Prix total de l'offre, pas un tarif mensuel." />
                </Question>
                <Question label="Durée moyenne d'un accompagnement (semaines)" required>
                  <NumberInput placeholder="ex. 6" value={d.duree_semaines} onChange={(v) => set("duree_semaines", v)} />
                </Question>
                <Question label="Clientes suivies en simultané (max)" required>
                  <NumberInput placeholder="ex. 4" value={d.clients_max} onChange={(v) => set("clients_max", v)} hint="En termes de temps et d'énergie." />
                </Question>
                <Question label="Clientes actives en ce moment" required>
                  <NumberInput placeholder="ex. 2" value={d.clients_actuels} onChange={(v) => set("clients_actuels", v)} />
                </Question>
                <Question label="Packs vendus sur les 3 derniers mois" required>
                  <NumberInput placeholder="ex. 3" value={d.ventes_3mois} onChange={(v) => set("ventes_3mois", v)} />
                </Question>
              </>
            )}

            {d.format_offre === "collectif" && (
              <>
                <Question label="Tarif de la cotisation ou de l'accès (€)" required>
                  <NumberInput placeholder="ex. 800" value={d.prix} onChange={(v) => set("prix", v)} hint="Cotisation annuelle, mensuelle ou accès unique." />
                </Question>
                <Question label="Membres actifs en ce moment" required>
                  <NumberInput placeholder="ex. 35" value={d.clients_actuels} onChange={(v) => set("clients_actuels", v)} />
                </Question>
                <Question label="Capacité maximale de ton offre collective" required>
                  <NumberInput placeholder="ex. 100" value={d.clients_max} onChange={(v) => set("clients_max", v)} hint="Sans dégrader l'expérience membre." />
                </Question>
                <Question label="Nouveaux membres sur les 3 derniers mois" required>
                  <NumberInput placeholder="ex. 8" value={d.ventes_3mois} onChange={(v) => set("ventes_3mois", v)} />
                </Question>
              </>
            )}

            {d.format_offre === "digital" && (
              <>
                <Question label="Prix de ton produit principal (€)" required>
                  <NumberInput placeholder="ex. 297" value={d.prix} onChange={(v) => set("prix", v)} />
                </Question>
                <Question label="Ventes par mois en moyenne" required>
                  <NumberInput placeholder="ex. 15" value={d.ventes} onChange={(v) => set("ventes", v)} />
                </Question>
              </>
            )}

            {errors.s3 && <div style={{ color: C.red, fontSize: 12, fontFamily: "'DM Mono', monospace", marginTop: 8 }}>{errors.s3}</div>}
            <div style={S.nav}>
              <button style={S.btnBack} onClick={() => go(2)}>← Retour</button>
              <span style={S.counter}>3 / 5</span>
              <button style={S.btnNext(false)} onClick={() => go(4)}>Suivant →</button>
            </div>
          </div>
        )}

        {/* ── STEP 4 : ACQUISITION ── */}
        {step === 4 && (
          <div>
            <div style={S.tag}>Étape 4 / 5 — Acquisition</div>
            <h2 style={S.h1}>Comment tu<br /><em>attires des clientes ?</em></h2>
            <Question label="D'où viennent principalement tes clientes ? (plusieurs choix)">
              <div style={S.choiceGrid(1)}>
                {[
                  ["reseaux_sociaux", "Réseaux sociaux (Instagram, LinkedIn…)"],
                  ["bouche_oreille", "Bouche à oreille / Recommandations"],
                  ["contenu", "Contenu (newsletter, blog, SEO…)"],
                  ["publicite", "Publicité payante"],
                  ["evenements", "Événements / Networking"],
                  ["mixte", "Mixte / plusieurs canaux"],
                ].map(([v, l]) => (
                  <div key={v}>{multiCheck(v, l)}</div>
                ))}
              </div>
            </Question>
            <Question label="Combien de personnes manifestent un intérêt concret pour ton offre chaque mois ?" required>
              <NumberInput placeholder="ex. 5" value={d.prospects} onChange={(v) => set("prospects", v)} hint="Prises de contact, demandes d'infos, messages sérieux — peu importe le canal." />
            </Question>
            {errors.s4 && <div style={{ color: C.red, fontSize: 12, fontFamily: "'DM Mono', monospace", marginTop: 8 }}>{errors.s4}</div>}
            <div style={S.nav}>
              <button style={S.btnBack} onClick={() => go(3)}>← Retour</button>
              <span style={S.counter}>4 / 5</span>
              <button style={S.btnNext(false)} onClick={() => go(5)}>Suivant →</button>
            </div>
          </div>
        )}

        {/* ── STEP 5 : CONVERSION ── */}
        {step === 5 && (
          <div>
            <div style={S.tag}>Étape 5 / 5 — Conversion</div>
            <h2 style={S.h1}>Transformer l'intérêt<br /><em>en vente.</em></h2>
            <p style={S.desc}>C'est là où beaucoup de business perdent de l'argent sans le savoir.</p>
            <Question label="Sur 10 personnes intéressées, combien deviennent clientes ?" required>
              <ScaleInput value={d.conv_sur_10} onChange={(v) => set("conv_sur_10", v)} />
            </Question>
            <Question label="Avant d'acheter, tes prospects ont besoin de beaucoup d'explications ?">
              {choicesObj("offre_comprise", [["non", "Non, l'offre parle d'elle-même"], ["oui", "Oui, je dois souvent clarifier"]], 2)}
            </Question>
            <Question label="Tu te sens proche de la saturation ?">
              {choicesObj("saturation", [["oui", "Oui"], ["non", "Non"]], 2)}
            </Question>
            {errors.s5 && <div style={{ color: C.red, fontSize: 12, fontFamily: "'DM Mono', monospace", marginTop: 8 }}>{errors.s5}</div>}
            <div style={S.nav}>
              <button style={S.btnBack} onClick={() => go(4)}>← Retour</button>
              <span style={S.counter}>5 / 5</span>
              <button style={S.btnNext(true)} onClick={handleSubmit}>Obtenir mon diagnostic →</button>
            </div>
          </div>
        )}


        {/* ── STEP 6 : RÉSULTATS ── */}
        {step === 6 && results && (() => {
          const r = results;
          const profil = PROFILS[r.profil];
          const prios = r.prios;
          const verdictType = r.statut;
          const verdictCopy = {
            atteignable: { icon: "✦", title: "Votre objectif est atteignable avec votre modèle actuel.", text: `Votre capacité maximale (${fmt(r.cap_max)}/mois) est suffisante pour atteindre ${fmt(d.objectif_ca)}. La question n'est pas le modèle — c'est ce qui vous empêche de le remplir.` },
            tendu: { icon: "◆", title: "Votre objectif est atteignable, mais le modèle est tendu.", text: `Votre capacité maximale (${fmt(r.cap_max)}/mois) couvre l'objectif avec peu de marge. Acquisition, conversion et capacité doivent fonctionner simultanément.` },
            non_atteignable: { icon: "●", title: "Votre objectif n'est pas atteignable avec le modèle actuel.", text: `Même en remplissant la capacité à 100%, vous ne pouvez générer que ${fmt(r.cap_max)}/mois. Atteindre ${fmt(d.objectif_ca)} nécessite de revoir la structure économique.` },
          }[verdictType];

          return (
            <div>
              <div style={S.rHeader}>
                <div style={S.rEyebrow}>Diagnostic complet · {d.prenom}</div>
                <div style={S.rTitle}>Votre analyse stratégique</div>
                <div style={S.rSub}>
                  {verdictType === "atteignable" && "Votre modèle peut supporter votre objectif — voyons ce qui freine."}
                  {verdictType === "tendu" && "Votre modèle est au maximum de sa tension — le moindre levier compte."}
                  {verdictType === "non_atteignable" && "Votre modèle a besoin d'évoluer pour atteindre cet objectif."}
                </div>
              </div>

              {/* VERDICT */}
              <div style={S.verdict(verdictType)}>
                <div style={{ fontSize: 20, marginBottom: 6 }}>{verdictCopy.icon}</div>
                <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 20, marginBottom: 8 }}>{verdictCopy.title}</div>
                <div style={{ fontSize: 14, lineHeight: 1.65 }}>{verdictCopy.text}</div>
              </div>

              {/* SITUATION */}
              <div style={S.bloc}>
                <div style={S.blocTitle}>Vos indicateurs clés</div>
                <div style={S.metricsGrid}>
                  {[
                    ["CA actuel", fmt(r.ca_actuel), "par mois"],
                    ["Capacité max", fmt(r.cap_max), "plafond du modèle"],
                    ["Écart objectif", r.ecart > 0 ? fmt(r.ecart) : "✓ Atteint", "à combler"],
                    ["Clients requis", r.clients_requis ?? "—", "pour l'objectif"],
                  ].map(([l, v, s]) => (
                    <div key={l} style={S.metricCard}>
                      <div style={S.metricLabel}>{l}</div>
                      <div style={S.metricVal}>{v}</div>
                      <div style={S.metricSub}>{s}</div>
                    </div>
                  ))}
                </div>
                <UtilBar pct={r.util_pct} />
              </div>

              {/* BLOCAGES */}
              <div style={S.bloc}>
                <div style={S.blocTitle}>Où est le vrai problème</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                    <div style={{ width: 3, height: 40, background: C.red, flexShrink: 0 }} />
                    <div>
                      <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, letterSpacing: "0.18em", textTransform: "uppercase", color: C.warmGray, marginBottom: 3 }}>Blocage principal</div>
                      <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 17, fontWeight: 700 }}>{r.bp}</div>
                    </div>
                  </div>
                  {r.nuance && (
                    <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                      <div style={{ width: 3, height: 40, background: C.warmGray, flexShrink: 0 }} />
                      <div>
                        <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, letterSpacing: "0.18em", textTransform: "uppercase", color: C.warmGray, marginBottom: 3 }}>Nuance secondaire</div>
                        <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 17, fontWeight: 400 }}>{PROFILS[r.nuance]?.label}</div>
                      </div>
                    </div>
                  )}
                  {r.taux_conv_pct > 0 && (
                    <div style={{ marginTop: 4, padding: "12px 14px", background: C.white, borderLeft: `3px solid ${C.ink}`, fontSize: 13 }}>
                      Taux de conversion observé : <strong>{r.taux_conv_pct}%</strong> — {r.taux_conv_pct < 10 ? "faible" : r.taux_conv_pct < 20 ? "moyen" : "bon"}
                    </div>
                  )}
                </div>
              </div>

              {/* PROFIL */}
              <div style={S.bloc}>
                <div style={S.profilBadge(profil.color)}>{profil.label}</div>
                <div style={S.profilText}>{profil.texte}</div>
              </div>

              {/* PRIORITÉS */}
              <div style={S.bloc}>
                <div style={S.blocTitle}>Vos 3 chantiers stratégiques</div>
                <div>
                  {prios.map((p, i) => (
                    <div key={i} style={{ ...S.prioItem, ...(i === prios.length - 1 ? { borderBottom: "none" } : {}) }}>
                      <span style={S.prioNum}>0{i + 1}</span>
                      <div>
                        <div style={{ fontWeight: 500, marginBottom: 4 }}>{p.t}</div>
                        <div style={{ fontSize: 13, color: C.warmGray }}>{p.d}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* VIDÉO — iframe embed direct */}
              {(() => {
                const embedId = "8e95Afavsfo";
                const embedUrl = `https://www.youtube.com/embed/${embedId}?si=HL6_DGU83WYSCkKx`;
                return (
                  <div style={{ ...S.bloc, borderTop: "3px solid " + C.red }}>
                    <div style={S.blocTitle}>Et maintenant ?</div>
                    <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, overflow: "hidden" }}>
                      <iframe
                        src={embedUrl}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none" }}
                      />
                    </div>
                  </div>
                );
              })()}

              {/* CTA UNIQUE — Capsule stratégique */}
              <div style={{ marginTop: 8, marginBottom: 12 }}>
                <div style={{ background: C.ink, borderLeft: `4px solid ${C.red}`, padding: "36px 28px 32px" }}>
                  <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, letterSpacing: "0.2em", textTransform: "uppercase", color: C.red, marginBottom: 12 }}>La prochaine étape</div>
                  <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 22, fontStyle: "italic", color: C.paper, marginBottom: 6, lineHeight: 1.3 }}>
                    Une capsule stratégique avec moi.
                  </div>
                  <div style={{ fontSize: 12, color: "rgba(245,240,232,0.5)", marginBottom: 24, lineHeight: 1.7, fontStyle: "italic" }}>
                    Un sujet précis. Un blocage identifié. Un arbitrage net.
                  </div>

                  {/* Ce avec quoi tu repars */}
                  <div style={{ marginBottom: 28 }}>
                    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                      {["Une vision claire", "Des décisions actées", "Des priorités tranchées", "Un plan d'action simple", "Un espace Notion dédié"].map((s, i) => (
                        <div key={i} style={{ display: "flex", gap: 10, alignItems: "baseline" }}>
                          <span style={{ color: C.red, fontSize: 11 }}>✔</span>
                          <span style={{ fontSize: 12, color: "rgba(245,240,232,0.65)", lineHeight: 1.6 }}>{s}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <a
                    href="https://www.womenwithaplan.fr/capsulestrategique"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "inline-block", background: C.red, color: C.paper, padding: "15px 36px", fontFamily: "'DM Mono', monospace", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", textDecoration: "none", fontWeight: 500, borderBottom: `3px solid ${C.redDark}` }}
                  >
                    Réserver ma capsule →
                  </a>

                  {params["CTA_WHATSAPP"] && (
                    <div style={{ marginTop: 18 }}>
                      <a
                        href={`https://wa.me/${params["CTA_WHATSAPP"].replace(/\D/g, "")}?text=${encodeURIComponent(params["CTA_WHATSAPP_MESSAGE"] || "Bonjour, je viens de faire le diagnostic Women With A Plan et j'aimerais en discuter avec toi.")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontFamily: "'DM Mono', monospace", fontSize: 10, letterSpacing: "0.12em", color: "rgba(245,240,232,0.4)", textDecoration: "none" }}
                      >
                        {params["CTA_TEXTE_SECONDAIRE"] || "Ou écris-moi directement →"}
                      </a>
                    </div>
                  )}
                </div>
              </div>

              {/* RESTART */}
              <div style={{ textAlign: "center", marginTop: 20 }}>
                <button onClick={restart} style={{ background: "none", border: "none", fontFamily: "'DM Mono', monospace", fontSize: 10, letterSpacing: "0.15em", textTransform: "uppercase", cursor: "pointer", color: C.border, padding: "8px 0" }}>
                  Nouveau diagnostic
                </button>
              </div>

              {/* FOOTER RS */}
              <div style={{ marginTop: 28, paddingTop: 20, borderTop: `3px solid ${C.ink}`, display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
                <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, letterSpacing: "0.18em", textTransform: "uppercase", color: C.warmGray }}>Retrouve-moi ici</div>
                <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
                  <a href="https://www.linkedin.com/in/coraline-deshaies/" target="_blank" rel="noopener noreferrer" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5, color: C.ink, textDecoration: "none" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
                    <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, letterSpacing: "0.1em" }}>LinkedIn</span>
                  </a>
                  <a href="https://www.instagram.com/women.withaplan/" target="_blank" rel="noopener noreferrer" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5, color: C.ink, textDecoration: "none" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
                    <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, letterSpacing: "0.1em" }}>Instagram</span>
                  </a>
                  <a href="https://www.womenwithaplan.fr/bold-women-list" target="_blank" rel="noopener noreferrer" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 5, color: C.ink, textDecoration: "none" }}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                    <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 9, letterSpacing: "0.1em" }}>Newsletter</span>
                  </a>
                </div>
                <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 11, color: C.border, fontStyle: "italic", marginTop: 4 }}>Women With A Plan © 2025</div>
              </div>
            </div>
          );
        })()}

      </div>
    </div>
  );
}
